module.exports = __webpack_public_path__ + "static/media/marek-ios.312a1d93.png";